import apiClient from 'utilities/apiClient';

export const getTasks = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const getUsers = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const assign_tasks = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const assigned_tasks = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.plans}/${url}`, payload, true);
};

export const unassign_tasks = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const highlight_task = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const un_highlight_task = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const publish_plan = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const plan_analytics = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.plans}/${url}`, payload, true);
};

export const get_all_clients = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.clients}/${url}`, payload, true);
};

export const get_all_Projects = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.projects}/${url}`, payload, true);
};

export const create_new_task = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tasks}/${url}`, payload, true);
};

export const get_plans = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.plans}/${url}`, payload, true);
};

export const get_speechmatic_jwt = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.speechmatic}/${url}`, payload, true);
};

export const updateLeave = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.users}/${url}`, payload, true);
};
